import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loadingRow: {
		id: 'virtual-table.app.table.loading-row.loading-row',
		defaultMessage: 'Loading row contents',
		description: 'Indicates a row is loading for screen readers',
	},
});
